export default "! HS12-24_25no23.scl\n!\nHS12-24_25no23\n 12\n!\n25/24\n13/12\n7/6\n5/4\n4/3\n17/12\n3/2\n19/12\n5/3\n7/4\n11/6\n2/1\n"